import type { DropdownData } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { list } from '../../../../../common/classes/request-builder';
import { SectorModel } from 'src/app/models/form-common/sector.model';

export class SectoresListsDefinition {
  distanciasGoteros: DropdownData<string> =  list(
      ['...', null],
      '25cm',
      '30cm',
      '50cm',
      '95cm',
      '100cm'
  );
     
  fincas: DropdownData<SectorModel> = {
      selected: null,
      filtered: [{label: '...', value: null}],
      values: []
  };
 
  jardines: DropdownData<SectorModel> = list<SectorModel>(['...', null]); 
}